export const environment = {
	baseApiUrl: 'https://dev.wayout.rs/api',
	baseUrl: 'https://dev-admin.wayout.rs',
};
